module.exports = {"id":"188414","name":"Carlos Villanueva","rating":"76","photo":"./data/images/photos/3/188414.png","club":{"name":"Al Ittihad","logo":"./data/images/clubs/AlIttihad.png"},"positions":["MOC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosVillanueva0.json
// module id = 730
// module chunks = 0